import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, Settings, Users as UsersIcon } from 'lucide-react';
import { Avatar } from './Avatar.js';
import { Button } from './Button.js';
import { NavBar } from './NavBar.js';
import { useAuth } from '../lib/auth-context.js';
import { hasAtLeastRole } from '@portal/shared';

export interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { user, me, signOut } = useAuth();
  const canManageUsers = !!me && hasAtLeastRole(me.role, 'admin');
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar
        userMenu={
          <div className="flex items-center gap-2">
            {canManageUsers && (
              <Link to="/settings/users">
                <Button
                  variant="ghost"
                  size="sm"
                  leftIcon={<UsersIcon className="size-4" aria-hidden />}
                >
                  Users
                </Button>
              </Link>
            )}
            <Link to="/settings/profile">
              <Button
                variant="ghost"
                size="sm"
                leftIcon={<Settings className="size-4" aria-hidden />}
              >
                Profile
              </Button>
            </Link>
            {user && <Avatar name={user.displayName ?? user.email ?? 'User'} size="sm" />}
            <span className="text-sm text-text-secondary hidden sm:inline">
              {user?.displayName ?? user?.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => signOut()}
              leftIcon={<LogOut className="size-4" aria-hidden />}
            >
              Sign out
            </Button>
          </div>
        }
      />
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
